import React from 'react';
import { Button } from './ui/Button';

export const SessionRecoveryPanel = ({ reason, retrying, onRetry, onLogout }: {
  reason: 'offline' | 'temporary' | 'unavailable';
  retrying: boolean;
  onRetry: () => void;
  onLogout: () => void;
}) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white px-4">
    <section aria-labelledby="session-recovery-title" className="w-full max-w-md rounded-2xl border border-slate-700 bg-slate-900 p-8 space-y-5">
      <h1 id="session-recovery-title" className="text-2xl font-bold">Connection recovery</h1>
      <p role="status" aria-live="polite">
        {retrying ? 'Verifying your session…' : reason === 'offline'
          ? 'You’re offline. We’ll retry when your connection returns.'
          : reason === 'temporary'
            ? 'Your session could not be verified. Try again if the connection does not recover.'
            : 'We could not verify your access. Try again, or contact Admin if this continues.'}
      </p>
      <p className="text-sm text-slate-300">CRM access is paused until your session and Admin access are verified.</p>
      <div className="flex gap-3">
        <Button onClick={onRetry} disabled={retrying}>{retrying ? 'Checking…' : 'Try again'}</Button>
        <Button variant="outline" onClick={onLogout}>Sign out</Button>
      </div>
    </section>
  </div>
);
